import Stack from '@mui/material/Stack'
import { themeConfig } from '@gap/shared/theme'
export default function CenterFullScreen(props: { children: React.ReactNode }) {
   return (
      <Stack sx={{
         justifyContent: 'center',
         minHeight: '100vh',
         backgroundColor: themeConfig.light.background.alt,
      }}>
         {props.children}
      </Stack>
   )
}
